import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getHotComics } from '@/mocks/comics';

export default function HotSection() {
  const hotComics = getHotComics();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门<span className="text-accent-600">排行</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的热门韩漫，千万不要错过</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {hotComics.map((comic, index) => (
            <div key={comic.id} className="relative">
              {index < 3 && (
                <div className="absolute top-0 left-3 z-10 w-8 h-10 flex items-center justify-center rounded-b-lg bg-accent-500 text-background-50 text-sm font-bold">
                  {index + 1}
                </div>
              )}
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}